module.exports = __webpack_public_path__ + "img/team3.93f368aa.png";